<div class="fdd-anomaly" [style.borderColor]="anomalyColor()">
  <div class="fdd-anomaly__head" [style.background]="anomalyColor() + '22'">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ 'FIELD_DETAILS_V2.ANOMALY_DETECTED' | translate }}</span>
  </div>
  <div class="fdd-anomaly__body">
    <div>
      <span class="muted">{{ 'FIELD_DETAILS_V2.ANOMALY_TYPE' | translate }}:</span>
      @if (anomalyTypeKey()) {
        <span>{{ anomalyTypeKey() | translate }}</span>
      } @else {
        <span>—</span>
      }
    </div>
    <div>
      <span class="muted">{{ 'Detection date' | translate }}:</span>
      {{ anomalyDetectionDate() | date: 'dd.MM.yyyy' }}
    </div>
    <button pButton type="button" class="p-button-sm p-button-text" (click)="onShowOnMap()">
      {{ 'ANOMALIES_SHOW_ON_MAP' | translate }}
    </button>
  </div>
</div>
